<template>
  <div class="weater_content">
    <iframe src="" width="100%" :height="height" frameborder="0" scrolling="auto" style="margin-top:2rem"></iframe>
  </div>
</template>
<script>
export default {
  name: 'Weather',
  data () {
    return {
      height: '100%'
    }
  }
}
</script>
<style scoped>
.weater_content{
  height:100%;
  position: relative;
  margin-top: -144px;
}
iframe{
  position:absolute;
  top:0;
  left: 0;
}
</style>
